import { render, staticRenderFns } from "./DetailFixedAssetCategory.vue?vue&type=template&id=6d880913"
import script from "./DetailFixedAssetCategory.vue?vue&type=script&lang=js"
export * from "./DetailFixedAssetCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports